module.exports = __webpack_public_path__ + "static/media/vencimiento_verde.12f7dae0.svg";